import { ace_index } from '@axo/shared/data-access/types';

export const aceIndexKeys = {
  root: ['ace-index'] as const,

  query: (query: ace_index.FindInput) =>
    [...aceIndexKeys.root, 'query', query] as const,

  workingLists: (aud?: ace_index.Audience) =>
    [...aceIndexKeys.root, 'working-lists', aud] as const,

  workingListDetail: (id: string) =>
    [...aceIndexKeys.root, 'working-list-detail', id] as const,

  options: () => [...aceIndexKeys.root, 'options'] as const,
};
